<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row>
        <v-col cols="12" sm="12" class="left--right-00">
          <!-- <div class="text-center">Assign Test for Verification</div> -->
          <div class="text-center text-bold">
            {{ testName }}
          </div>
        </v-col>
      </v-row>
      <v-row class="Schedule-block">
        <v-col cols="2" sm="2" class=""> </v-col>
        <v-col cols="6" sm="6" class="text-center  text-bold"
          >Verified By
        </v-col>
        <v-col cols="2" sm="2" class="">
          <div class="text-center text-bold">
            Assigned On
          </div></v-col
        >
        <v-col cols="2" sm="2" class="">
          <div class="text-center text-bold">
            Approved On
          </div>
        </v-col>
      </v-row>
      <v-row class="assign-list">
        <v-row
          class="margin-0 subject-row Schedule-block"
          v-for="(sub, idx) in tableData"
          :key="idx"
        >
          <v-col cols="2" sm="2" class="text-right">{{ sub.subject }}: </v-col>
          <v-col cols="6" sm="6" class="text-center"
            >{{ sub.assigned_to_user }}
          </v-col>
          <v-col cols="2" sm="2" class="text-center ">{{
            computedDateFormattedMomentjs(sub.created_at, "DD-MMM-YYYY")
          }}</v-col>
          <v-col cols="2" sm="2" class="text-center ">
            {{
              computedDateFormattedMomentjs(sub.approved_at, "DD-MMM-YYYY")
            }}</v-col
          >
        </v-row>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  name: "AssignedTestApprovalStatus",
  props: ["onClose", "status", "data"],
  data() {
    return {
      mode: this.data.selectedTest ? this.data.selectedTest.visible : null,
      selectedTest: this.data.selectedTest,
      tableData: [],
      testName: this.data.selectedTest.test_name,
      loading: false,
    };
  },
  mounted() {
    this.assignTestCall();
  },
  methods: {
    ...mapActions({
      assignTestStatus: "testStore/assignTestStatus",
    }),

    assignTestCall() {
      let getData = {
        testId: this.selectedTest.id,
      };
      let me = this;
      this.$root.showLoader = true;
      this.assignTestStatus(getData)
        .then((response) => {
          me.$root.showLoader = false;
          me.tableData = response;
        })
        .catch((err) => {
          me.$toasted.error("Error getting approval status.");
          me.$root.showLoader = false;
        });
    },
  },
  watch: {
    status(val) {
      this.selectedTest = this.data.selectedTest;
      this.testName = this.data.selectedTest.test_name;
      if (val) this.assignTestCall();
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
};
</script>
